module.exports = __webpack_public_path__ + "static/media/navigate_next_black_24dp.84a065e9.svg";